import { QueryKey, useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import queryString from 'query-string';
import { MetricEntry } from './types';
import { prefetchData } from './prefetchData';

const getConditionsLevels = async ({ signal }: { signal?: AbortSignal }): Promise<MetricEntry[]> => {
  const res = await apiClient.get<{ data: MetricEntry[] }>(`/conditions/levels`, {
    signal,
    paramsSerializer: (prms) => queryString.stringify(prms, { arrayFormat: 'comma' }),
  });
  return res.data.data;
};

interface UseConditionsLevel<TData> {
  config?: QueryConfig<typeof getConditionsLevels, TData>;
}

export const useConditionsLevels = <TData = MetricEntry[]>({ config }: UseConditionsLevel<TData>) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getConditionsLevels({ signal }),
    queryKey: ['conditions', 'levels'] as QueryKey,
  });
};

export const prefetchConditionsLevels = async () =>
  await prefetchData(getConditionsLevels, ['conditions', 'levels'] as const);
